import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';

export default function RealStory() {
    const { t } = useLang('communitylang.realStory');
    const { Link } = useGlobal();

    return (
        <div className={`real-story ${css.realStory}`}>
            <div className="story-content">
                <p className="story-title">{t('title')}</p>
            </div>
            <div className="story-box">
                <Swiper modules={[Navigation, Pagination]} pagination navigation className="card-swiper" grabCursor slidesPerView={1}>
                    <SwiperSlide className="swiper-item">
                        <div className="cards-box">
                            <Link
                                href="https://bit.ly/3pkCDH0"
                                ariaLabel={t('join')}
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'community_button',
                                    list_name: t('title'),
                                    button_name: t('card_1_name'),
                                }}
                            >
                                <div className="card-item">
                                    <div className="img-box">
                                        <div className="area-img">
                                            <NextImage src={require('@publicLocal/community/pc/story_1.jpg')} />
                                        </div>
                                    </div>

                                    <p className="item-title">{t('card_1_name')}</p>
                                    <p className="item-desc">{t('card_1_desc')}</p>
                                </div>
                            </Link>
                            <Link
                                href="https://bit.ly/3JnbMAS"
                                ariaLabel={t('join')}
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'community_button',
                                    list_name: t('title'),
                                    button_name: t('card_2_name'),
                                }}
                            >
                                <div className="card-item">
                                    <div className="img-box">
                                        <div className="area-img">
                                            <NextImage src={require('@publicLocal/community/pc/story_2.jpg')} />
                                        </div>
                                    </div>
                                    <p className="item-title">{t('card_2_name')}</p>
                                    <p className="item-desc">{t('card_2_desc')}</p>
                                </div>
                            </Link>
                            <Link
                                href="https://bit.ly/46eF12U"
                                ariaLabel={t('join')}
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'community_button',
                                    list_name: t('title'),
                                    button_name: t('card_3_name'),
                                }}
                            >
                                <div className="card-item">
                                    <div className="img-box">
                                        <div className="area-img">
                                            <NextImage src={require('@publicLocal/community/pc/story_3.jpg')} />
                                        </div>
                                    </div>
                                    <p className="item-title">{t('card_3_name')}</p>
                                    <p className="item-desc">{t('card_3_desc')}</p>
                                </div>
                            </Link>
                            <Link
                                href="https://bit.ly/42IX4v6"
                                ariaLabel={t('join')}
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'community_button',
                                    list_name: t('title'),
                                    button_name: t('card_4_name'),
                                }}
                            >
                                <div className="card-item">
                                    <div className="img-box">
                                        <div className="area-img">
                                            <NextImage src={require('@publicLocal/community/pc/story_4.jpg')} />
                                        </div>
                                    </div>
                                    <p className="item-title">{t('card_4_name')}</p>
                                    <p className="item-desc">{t('card_4_desc')}</p>
                                </div>
                            </Link>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide className="swiper-item">
                        <div className="cards-box">
                            <Link
                                href="https://bit.ly/3JojFGu"
                                ariaLabel={t('join')}
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'community_button',
                                    list_name: t('title'),
                                    button_name: t('card_5_name'),
                                }}
                            >
                                <div className="card-item">
                                    <div className="img-box">
                                        <div className="area-img">
                                            <NextImage src={require('@publicLocal/community/pc/story_5.jpg')} />
                                        </div>
                                    </div>
                                    <p className="item-title">{t('card_5_name')}</p>
                                    <p className="item-desc">{t('card_5_desc')}</p>
                                </div>
                            </Link>
                            <Link
                                href="https://bit.ly/3qX1Ojl"
                                ariaLabel={t('join')}
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'community_button',
                                    list_name: t('title'),
                                    button_name: t('card_6_name'),
                                }}
                            >
                                <div className="card-item">
                                    <div className="img-box">
                                        <div className="area-img">
                                            <NextImage src={require('@publicLocal/community/pc/story_6.jpg')} />
                                        </div>
                                    </div>
                                    <p className="item-title">{t('card_6_name')}</p>
                                    <p className="item-desc">{t('card_6_desc')}</p>
                                </div>
                            </Link>
                            <Link
                                href="https://bit.ly/43M5Iuc"
                                ariaLabel={t('join')}
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'community_button',
                                    list_name: t('title'),
                                    button_name: t('card_7_name'),
                                }}
                            >
                                <div className="card-item">
                                    <div className="img-box">
                                        <div className="area-img">
                                            <NextImage src={require('@publicLocal/community/pc/story_7.jpg')} />
                                        </div>
                                    </div>
                                    <p className="item-title">{t('card_7_name')}</p>
                                    <p className="item-desc">{t('card_7_desc')}</p>
                                </div>
                            </Link>
                        </div>
                    </SwiperSlide>
                </Swiper>
            </div>
        </div>
    );
}
